import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  toggle() {
    const input = this.inputTarget
    const isPassword = input.type === "password"
    input.type = isPassword ? "text" : "password"

    const toggleButton = this.element.querySelector("button[data-action*='password-toggle#toggle']")
    if (!toggleButton) return

    toggleButton.classList.toggle("text-coffee", isPassword)
    toggleButton.classList.toggle("text-gray-100", !isPassword)
    toggleButton.setAttribute("aria-label", isPassword ? "Hide password" : "Show password")
  }
}
